import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { isString } from '@sniptt/guards';

import { type GraphqlErrorExtensions } from '@/apollo/types/GraphqlErrorExtensions';

const readString = (value: unknown) => (isString(value) ? value : null);

// One entry per GraphQL error; an empty list for anything else (the server
// couldn't be reached, or answered with something that isn't GraphQL).
export const getGraphqlErrorExtensions = (
  error: unknown,
): GraphqlErrorExtensions[] => {
  if (!CombinedGraphQLErrors.is(error)) {
    return [];
  }

  return error.errors.map(({ extensions }) => ({
    code: readString(extensions?.code),
    subCode: readString(extensions?.subCode),
    userFriendlyMessage: readString(extensions?.userFriendlyMessage),
  }));
};
